import apiService from '../apiService';

const SPECIALITY_URL = 'contacts/specialities'

const specialityService = {

    async createSpeciality(payload) {
        try {
            const response = await apiService.post(`/${SPECIALITY_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllSpecialities(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${SPECIALITY_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleSpeciality(id) {
        try {
            const response = await apiService.get(`/${SPECIALITY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateSpeciality(payload, id) {
        try {
            const response = await apiService.put(`/${SPECIALITY_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteSpeciality(id) {
        try {
            const response = await apiService.delete(`/${SPECIALITY_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default specialityService;
